import { render, staticRenderFns } from "./editSentenceGroupPage.vue?vue&type=template&id=f34b92cc&"
import script from "./editSentenceGroupPage.vue?vue&type=script&lang=js&"
export * from "./editSentenceGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./editSentenceGroupPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports